<template>
  <div class="confirm">
    <b-form @submit="submitForm">
      <b-form-group id="station-number-group">
        <label label-for="station-number">
          Vehicle Testing Station Number
          <span class="text-danger">*</span>
        </label>
        <b-form-input
          class="uppercase"
          v-model="vtsInfo.vts_number"
          variant="success"
          id="station-number"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="garage-name-group">
        <label label-for="garage-name">
          Garage Name
          <span class="text-danger">*</span>
        </label>
        <b-form-input v-model="vtsInfo.name" id="garage-name" type="text" required></b-form-input>
      </b-form-group>

      <b-form-group id="address-line-1-group" label="Address Line 1" label-for="address-line-1">
        <b-form-input v-model="vtsInfo.address1" id="address-line-1" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="address-line-2-group" label="Address Line 2" label-for="address-line-2">
        <b-form-input v-model="vtsInfo.address2" id="address-line-2" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="address-line-3-group" label="Address Line 3" label-for="address-line-3">
        <b-form-input v-model="vtsInfo.address3" id="address-line-3" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="town-city-group" label="Town/City" label-for="town-city">
        <b-form-input v-model="vtsInfo.town" id="town-city" type="text"></b-form-input>
      </b-form-group>

      <b-form-group id="postcode-group" label="Postcode" label-for="postcode">
        <b-form-input v-model="vtsInfo.postcode" id="postcode" type="text"></b-form-input>
      </b-form-group>

      <b-alert :show="$store.state.viewState == 'Error'" variant="danger">
        <span v-if="$store.state.error">{{ $store.state.error }}</span>
        Error processing activation, please contact our team directly who will be glad to assist.
      </b-alert>

      <b-button block size="lg" type="submit" variant="success">
        Confirm Details
        <span class="mdi mdi-login-variant ml-2"></span>
      </b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "confirm",
  data() {
    return {
      vtsInfo: {}
    };
  },
  mounted() {
    this.vtsInfo = this.$store.state.vtsInfo;
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.vtsInfo.vts_number = this.vtsInfo.vts_number.trim().toUpperCase();
      this.$store.dispatch("confirmDetails", this.vtsInfo);
      this.$router.push({ name: "activate-request" });
    }
  }
};
</script>